import { render } from "./ReceiptsReport.vue?vue&type=template&id=777f8e54"
import script from "./ReceiptsReport.vue?vue&type=script&lang=js"
export * from "./ReceiptsReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__